import {
    Routes,
    Route,
} from "react-router-dom";

import AdminSettingsPage from "./admin-settings.page.component";
import QuestionnairesRoutes from "./questionnaires/questionnaire.routes";
import AppSettings from "./app-settings/app-settings.page.component";


export default function AdminSettingsRoutes() {
    return (
        <Routes>
            <Route path="/" element={<AdminSettingsPage />} />
        <Route path="/questionnaires/*" element={<QuestionnairesRoutes />} />
        <Route path="/app-settings/:page/*" element={<AppSettings  />} />
        </Routes>
    )
}